import React from'react';
import styled from '@emotion/styled';

interface HeaderMobileProps {
  disable: boolean;
}
const HeaderMobile:React.FC<HeaderMobileProps> = ({ disable }) => {
  const handleGotoHomapage:React.MouseEventHandler<HTMLDivElement> | undefined = () => {
    window.location.href="https://photypeta.com"
  };

  const handleGotologin = () => {
    window.location.href="https://app.photypeta.com/login"
  }
  
  return(
    <Container>
      <ImgContainer
        onClick={!disable ? undefined : handleGotoHomapage}
      >
        <LogoImg src='/images/logoImg2.png'/>
      </ImgContainer>
    </Container>
  )
};

export default HeaderMobile;

const Container = styled.div`
  width: 100%;
  height: 69px;
  
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
const ImgContainer = styled.div`
  width: 118px;
  height: 25.62px;
  margin-left: 17px;
`
const LogoImg = styled.img`
  width: 100%;
`;
const LogoutContainer = styled.div`
  margin-right: 22px;
  font-family: 'Pretendard'; 
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  white-space:nowrap ;
  color:#797979;
`